/**
 * Use `useSendPrintToIntacct` hook to send print request to Intacct instead of using this directly
 * to ensure that the timesheet is saved before sending the print request.
 *
 * @param intacctTimesheetRecordNo Timesheet record number in Intacct
 * @param targetOrigin https://dev01.intacct.com
 */
export function sendPrintToIntacct(intacctTimesheetRecordNo: string | number, targetOrigin: string) {
  window.parent.postMessage(
    JSON.stringify({
      function: 'open_pdf_pop_up',
      p_op: '4887', // op-code for timesheet. You can find this by inspecting HTML on Intacct.
      p_it: 'timesheet',
      p_r: `${intacctTimesheetRecordNo}`,
      p_mod: 'pa',
      p_title: 'Timesheet',
    }),
    targetOrigin,
  );
}

/**
 * @param intacctTimesheetRecordNo Timesheet record number in Intacct
 * @param targetOrigin https://dev01.intacct.com
 */
export function sendOpenAuditPopup(intacctTimesheetRecordNo: string | number, targetOrigin: string) {
  window.parent.postMessage(
    JSON.stringify({
      function: 'open_audit_pop_up',
      p_it: 'timesheet',
      p_r: `${intacctTimesheetRecordNo}`,
    }),
    targetOrigin,
  );
}
